import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class RideBookingsActions {
    static FETCH_RIDE_BOOKINGS = '[RideBookings]: Fetch start';
    static FETCH_RIDE_BOOKINGS_SUCCESS = '[RideBookings]: Fetch success';
    static FETCH_RIDE_BOOKINGS_ERROR = '[RideBookings]: Fetch error';

    fetchRideBookings(): RidangoReduxAction {
        return {
            type: RideBookingsActions.FETCH_RIDE_BOOKINGS,
        };
    }

    fetchRideBookingsSuccess(payload: any): RidangoReduxAction {
        return {
            type: RideBookingsActions.FETCH_RIDE_BOOKINGS_SUCCESS,
            payload: payload,
        };
    }

    fetchRideBookingsFail(error: any): RidangoReduxAction {
        return {
            type: RideBookingsActions.FETCH_RIDE_BOOKINGS_ERROR,
            payload: error,
        };
    }
}

